/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_Decks_FinalistsInputs */



/**
* | output |
* | --- |
* | "The finalists' decklists become public" |
*
* @param {Finish_Confirm_Decks_FinalistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_decks_finalists = /** @type {((inputs?: Finish_Confirm_Decks_FinalistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Decks_FinalistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les decklists des finalistes deviennent publiques")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las decklists de los finalistas se hacen públicas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As decklists dos finalistas se tornam públicas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le decklist dei finalisti diventano pubbliche")
	return /** @type {LocalizedString} */ ("The finalists' decklists become public")
});